/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What input does a histogram need?`)
};

const es_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué entrada necesita un histograma?`)
};

const de_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Eingabe benötigt ein Histogramm?`)
};

const nl_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke invoer heeft een histogram nodig?`)
};

const fr_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle entrée un histogramme nécessite-t-il ?`)
};

const it_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che input serve per un istogramma?`)
};

const pt_br2_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que entrada um histograma precisa?`)
};

const pt_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Que entrada precisa um histograma?`)
};

const ja_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヒストグラムにはどのような入力が必要ですか？`)
};

const zh_hist_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`直方图需要什么输入？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_faq_q1", locale)
	if (locale === "en") return en_hist_faq_q1(inputs)
	if (locale === "es") return es_hist_faq_q1(inputs)
	if (locale === "de") return de_hist_faq_q1(inputs)
	if (locale === "nl") return nl_hist_faq_q1(inputs)
	if (locale === "fr") return fr_hist_faq_q1(inputs)
	if (locale === "it") return it_hist_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_hist_faq_q1(inputs)
	if (locale === "pt") return pt_hist_faq_q1(inputs)
	if (locale === "ja") return ja_hist_faq_q1(inputs)
	return zh_hist_faq_q1(inputs)
};